import { render } from "./AdmDashboard.vue?vue&type=template&id=dcdb5302&scoped=true&ts=true"
import script from "./AdmDashboard.vue?vue&type=script&lang=ts"
export * from "./AdmDashboard.vue?vue&type=script&lang=ts"

import "./AdmDashboard.vue?vue&type=style&index=0&id=dcdb5302&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcdb5302"]])

export default __exports__